/*Add Staff Management to dynamic route Dec 11, 2022 */
/* Add main-header-sticky June 18, 2023 */
/* Add fn_checkPageEnabled,fn_checkValidRoute,fn_userEnabledPages  Apr 13, 2024 */
/* Add KT-RevenueForecasting.vue Aug 8, 2026 */
/* Add KT-Meetings.vue Sep 19, 2026  */
<template lang="pug">
	b-container(id="KBDP" fluid)
		//- Header
		b-row(class="main-header border main-header-sticky")
			b-col()
				div(@click="m_goToMain()")
					img(alt="KBDP Logo"  src="@/assets/logo-2.png" class="my-2" height="40")
				div(class="tenant-info")
					div(v-if="c_tenantLogoURL")
						img(:src="c_tenantLogoURL"  height="50")
					div {{c_tenantName}}
			b-col()
				top-hdr()
				top-nav() 
		//- Admin
		admin(v-if="d_hashBase=='admin' && d_usrInf.tntAdmn")
		//- Settings
		settings(v-else-if="d_hashBase=='settings' && d_perms.EAS")
		//- Side + Main
		b-row(v-else class="flex-wrap flex-sm-nowrap")
			b-col(id="kbdp-side-nav" class="px-0")
				side-nav(ref="side-nav")
				div(v-if="c_isTouch" class="tap-close" @touchstart="m_tapClose")
			b-col(id="kbdp-main-nav" class="border" )
				//- Main Info (Home)
				div(v-if="(d_hashBase||null)==null" class="kbdp-main-info") 
					div(class="mb-auto py-1")
						img(alt="KBDP logo"  src="@/assets/logo-1.png" class="my-1" height="100")
						p Welcome to Kiese Business Development Platform
					
					kt-home-dashboard
					div(class="kt-announcements")
						div(class="header")
							fa-icon(icon="bullhorn")
							span Team Announcements
						div(v-if="d_teamAnnc.length==0" class="py-3 text-center") There are currently no team announcements
						div(v-else class="items")
							div(v-for="(item,ix) in d_teamAnnc" :key="ix" class="item")
								span(class="dt") {{d_util.fn_fmtDt(item.date)}}
								span(class="txt") {{item.text}}

					kt-reminders
					div(class="mt-auto py-1")
						div(class="small")
							div
								span You are currenly logged in as 
								b {{(d_usrInf.teamMember||{}).teamMemberName || d_usrInf.username}}
							div Last log in was on {{d_util.fn_fmtDtmStr(d_usrInf.lastLoginUTC, true)}} 
							div Current log in is on {{d_usrInf.auth_time_str}}
						div(class="small")
							div 
				
				//- Component (Rec/Nav)
				div(v-if="d_error" class="text-center mt-4")
					p(class="text-danger") Something went wrong ☹
					p(class="my-1 small text-grey5") {{d_error}}
					p(class="small") Please try again or refresh your browser session.
				component(
					v-if="c_mainNavComp"
					v-show="!d_error"
					:is="c_mainNavComp" 
					:p_mode="c_recMode" 
					@error="d_error = $event"
					)
					//- slot props... fTM = filter Team Member, fCU = filter Current User
					//- Only applies to Cal,Dash, Nav (oppr,proj,acct). But DONT DO v-if="c_tmFilter" in the template below. Causes unnecessary re-renderings
					template(slot="team-member-filter" slot-scope="props")
						span(class="filter-note" v-if="/^(calendar|dashboard)$/.test(c_mainNavKey)") {{c_tmFilterLbl? 'Showing': ''}} {{c_tmFilterLbl}}
						span(class="filter-note" v-if="/^(salesGoals)$/.test(c_mainNavKey)") {{c_tmFilterLbl? 'Showing '+c_tmFilterLbl:"Showing Company's Sales Goals"}}
						span(class="filter-note" v-if="/^(revenueForecasting)$/.test(c_mainNavKey)") {{c_tmFilterLbl? 'Showing '+c_tmFilterLbl:"Showing Company's Revenue Forecast"}}
						div(class="filter")
							b-button(v-if="props.fCU" class="btn-cuFilter" :class="d_cuFilter?'filtered':null" variant="none"
								v-b-tooltip.hover.auto.ds500="'Filter My Records'"
								@click="d_cuFilter=!d_cuFilter||null; d_tmFilter=null")
								fa-layers
									fa-icon(icon="user-alt")
									fa-icon(:icon="['fas', 'filter']" transform="shrink-6 up-5 left-10" v-show="d_cuFilter")
							kt-select(v-if="props.fTM && (d_perms.VTMC||d_perms.VTMD||d_perms.STMSG||d_usrInf.tntAdmn)"
								p_appEntKey="team" p_placeholder="Filter Team Member"
								:p_currentVal="d_tmFilter" @change="d_tmFilter = $event.teamMemberId ? $event : null; d_cuFilter=null")
				kt-chat(v-if="c_checkChat")
		//- View Record In Modal
		b-modal(id="bm-kbdp-view-rec" size="lg" centered=true no-fade 
			hide-header-close no-close-on-backdrop no-close-on-esc header-bg-variant="light" 
			footer-class="justify-content-start" 
			)
			//--Modal Header
			template(slot="modal-header")
				span {{d_modalRec.hdrTitle}}
			//-View Record
			component(ref="rec-view" v-if="d_modalRec.recNo" :is="d_modalRec.imporCompRec" p_mode="view" :p_isModal="true" :p_recNo="d_modalRec.recNo")
			//--Modal Footer
			template(slot="modal-footer" slot-scope="{ ok, cancel, hide }")
				b-button(variant="outline-secondary" @click="m_modalRec_close()") Close
				span(class="btn btn-link" @click="m_modal_view(false)") Open in Current Tab
				span | 
				span(class="btn btn-link" @click="m_modal_view(true)") Open in New Tab
		//- View/Edit Task In Modal
		task-rec(v-if="d_taskRec" v-bind="d_taskRec" @closed="d_taskRec=null" @saved="d_taskRec.fn_saved($event)")
		//- Alert Message
		div(id="kt-alert" class="fixed-bottom" v-if="d_alert.ok||d_alert.err" )
			b-alert(show dismissible fade :variant="d_alert.err? 'warning': 'success'" 
				@dismissed="d_alert.msg=d_alert.err=d_alert.ok = null")
				span
					fa-icon(:icon="d_alert.err ? 'exclamation-triangle' : 'check-circle' ")
				pre {{d_alert.msg}}
		//- Waiting Message Modal
		b-modal(id="bm-kt-spinner" v-show="d_alert.spin" size="sm" centered=true no-fade hide-footer
			hide-headerx hide-header-closex no-close-on-backdrop no-close-on-esc hide-backdrop
			@close="d_alert.clear()"
			)
			div(class="text-center my-4")
				p {{d_alert.spinMsg}}
				div(class="spinner-border spinner-border-md text-primary" role="status")
</template>

<script>

import TopHdr from "@/components/TopHdr.vue";
import TopNav from "@/components/TopNav.vue";
import SideNav from "@/components/SideNav.vue";
import KTChat from "@/components/Ctrl/KT-Chat.vue";
import KTReminders from "@/components/Ctrl/KT-Reminders.vue";
import KTHomeDashboard from "@/components/Ctrl/KT-HomeDashboard.vue";

import util, {fn_checkPageEnabled,fn_checkValidRoute,fn_userEnabledPages,fn_saveUserOpts,fn_getHashBase} from "@/utils/util.js";
import {api_baseURL, fn_appEnt, userInfo, tenantSettings, userSettings, teamAnnouncements} from "@/utils/ref-data.js";

const const_kbdpAlert = {};
const const_kbdpRecord = {};
export default {
	name: "kbdp",
	components: {
		'top-hdr': TopHdr,
		'top-nav': TopNav,
		'side-nav': SideNav,
		'kt-chat': KTChat,
		'kt-reminders': KTReminders,
		'kt-home-dashboard': KTHomeDashboard,

		'admin': () => import("@/components/Admin.vue"),
		'settings': () => import("@/components/Settings.vue"),
		'task-rec': () => import("@/components/Rec/TaskRec.vue"),
	},
	created() {
		this.d_hashBase = fn_getHashBase(this);
		fn_prepKbdpAlert(this);
		fn_prepKbdpRecord(this);
		teamAnnouncements.fn_reCheck(0); //Recheck
	},
	mounted() {},
	data() {
		return {
			d_util: util,
			d_hashBase: null,
			d_error: null,
			d_usrInf: userInfo.getUserInfo(),
			d_perms: userSettings.permissions,
			d_teamAnnc: teamAnnouncements.announcements,
			d_alert: {
				msg: null,
				ok: null,
				err: null,
				spin: null,
				spinMsg: null,
				clear: () => {const_kbdpAlert.clear();}
			},
			d_modalRec: {
				appEntKey: null,
				recNo: null,
				imporCompRec: null,
				hdrTitle: null,
			},
			d_taskRec: null,

			d_cuFilter: null,
			d_tmFilter: null,
		};
	},
	props: {},
	computed: {
		c_checkChat(){return fn_checkPageEnabled('Team Chat');},
		c_tenantName() {
			return tenantSettings.general.tenantName || this.d_usrInf.appTenant.appTenantName;
		},
		c_tenantLogoURL() {
			let tl = tenantSettings.general.tenantLogoURL;
			if (tl)
				return api_baseURL + tl;
			else
				return null;
		},
		c_recMode() {
			let hb = this.d_hashBase || '';
			let mode = hb.substring(5); //view, edit, create
			let valid = /^(view|edit|create)$/.test(mode);
			return valid ? mode : null;
		},
		c_appEnt() {

			let hb = this.d_hashBase || '';
			let appEnt = hb.substring(0, 4);
			let valid = /^(oppr|proj|acct|cmpt|extr|team|cal-)$/.test(appEnt);
			if (valid) {
				let isTask = hb.endsWith('-activities');
				valid = this.c_recMode != null || isTask || hb.length == 4;
				if (valid) {
					let key = isTask ? 'task' : appEnt;
					return fn_appEnt(key);
				}
				else return null;
			}
			else if(hb=='staff') return hb;
			else return null;
		},
		c_mainNavKey() {
			console.log('c_mainNavKey');
			console.log(this.d_hashBase);
			let hb = this.d_hashBase || '';
			if (/^(dashboard|calendar|meetings|salesGoals|revenueForecasting|staff|addr)$/.test(hb)) return hb;
			else if (this.c_appEnt) {
				let mode = this.c_recMode; //view, edit, create
				return mode ? 'rec' : 'nav';
			}
			else if (hb != '') return 'inv';
			else return null;
		},
		c_mainNavComp() {
			console.log('c_mainNavComp');
			console.log(this.c_mainNavKey);
			switch (this.c_mainNavKey) {
				case 'dashboard': return () => import("@/components/Ctrl/KT-Dashboard.vue");
				case 'calendar': return () => import("@/components/Ctrl/KT-Calendar.vue");
				case 'salesGoals': return () => import("@/components/Ctrl/KT-SalesGoals.vue");
				case 'revenueForecasting': return () => import("@/components/Ctrl/KT-RevenueForecasting.vue");
				case 'meetings': return () => import("@/components/Ctrl/KT-Meetings.vue");
				case 'nav': return (this.c_appEnt || {}).importNavComp || null;
				case 'rec': return (this.c_appEnt || {}).importRecComp || null;
				case 'staff': return () => import("@/components/Ctrl/KT-Staffing.vue");
				case 'addr':return () => import("@/components/Nav/AddrNav.vue");
				default: return null;
			}
		},
		c_tmFilterLbl() {
			//Also referenced externally from the NAVs
			let txt;
			if (this.d_cuFilter) txt = 'My';
			else if (this.d_tmFilter) {
				let tmNm = this.d_tmFilter.teamMemberName;
				txt = tmNm + (tmNm.endsWith('s') ? "'" : "'s");
			}
			else return;

			let rec = (this.c_appEnt || {}).label || util.fn_humanizeLabel(this.c_mainNavKey);
			return `${txt} ${rec}`;
		},
		c_isTouch() {
			return this.$root.$children[0].d_isTouch;
		},
		c_cutmKey() {
			return this.d_cuFilter ? -1 : (this.d_tmFilter || {}).teamMemberId || null;
			//This is used in the dash/cal/sg/nav to refresh data when filter is changed
			//watch $parent.c_cutmKey
		}
	},
	methods: {
		m_goToMain() {
			if (this.$route.hash != '') {
				this.$router.push({name: 'KBDP'});
			}
		},
		m_modalRec_close() {
			this.$bvModal.hide('bm-kbdp-view-rec');
			Object.keys(this.d_modalRec).forEach(k => this.d_modalRec[k] = null);
		},
		m_modal_view(newTab) {
			let dm = this.d_modalRec;
			let href = util.fn_hrefVwRec(dm.appEntKey, dm.recNo);
			if (newTab) {
				window.open(href, '_blank');
			}
			else {
				this.m_modalRec_close();
				setTimeout(() => {
					window.open(href, '_self');
				}, 200);
			}
		},
		m_tapClose() {
			let sn = this.$refs['side-nav'];
			if (sn) sn.m_sidnavCollapse();
		},
		m_chkUnsv(next) {
			//Only called from router.js
			fn_checkUnsavedChanges(this, next);
		}
	},
	watch: {
		$route(nv, ov) {
			if (this.c_mainNavKey != 'inv') this.d_error = null;

			this.d_hashBase = fn_getHashBase(this);

			// Check if valid route.
			let hb = this.d_hashBase || '';
			let appEnt = hb.substring(0, 4);
			console.log('changing to:'+appEnt);
			if(!fn_checkValidRoute(appEnt)) this.$router.push({name: 'KBDP'}); 
			if (nv.hash == '') {
				teamAnnouncements.fn_reCheck(1);
			}
			if (this.d_alert.err) this.d_alert.clear();
		},
		'd_alert.spin'(nv) {
			let da = this.d_alert;
			if (nv) {
				da.ok = da.err = null;
				this.$bvModal.show('bm-kt-spinner');
			}
			else {
				this.$bvModal.hide('bm-kt-spinner');
				da.spinMsg = null;
			}
		},
		c_mainNavKey(nv, ov) {
			this.d_error = nv != 'inv' ? null : "Invalid Request - the page you are trying to reach does not exist or is not permitted.";
		}
	}
};

export {
	//Called from Util by the rest of the app
	const_kbdpAlert as kbdpAlert,
	const_kbdpRecord as kbdpRecord
};

function fn_prepKbdpAlert(vc) {
	let ka = const_kbdpAlert;
	let da = vc.d_alert;

	let to = null;
	ka.showOk = (msg, timer) => {
		da.msg = msg;
		da.ok = true;
		da.spin = da.err = null;
		to = setTimeout(() => {da.ok = da.msg = null;}, (timer || 5000));
	};
	ka.showErr = (msg) => {
		clearTimeout(to);
		da.msg = msg;
		da.err = true;
		da.spin = da.ok = null;
	};

	ka.showLoading = (msg, ldng) => {
		da.spinMsg = ldng ? 'Loading ' : '' + msg || '';
		da.spin = true;
	};
	ka.showSaving = (msg) => {
		da.spinMsg = 'Saving ' + msg;
		da.spin = true;
	};
	ka.showDeleting = (msg) => {
		da.spinMsg = 'Deleting ' + msg;
		da.spin = true;
	};

	ka.clear = () => {
		Object.keys(da).filter(k => k != "clear").forEach(k => da[k] = null);
	};
}

function fn_prepKbdpRecord(vc) {
	let kvr = const_kbdpRecord;

	kvr.showRecord = (appEntKey, recNo) => {
		let dm = vc.d_modalRec;
		let ae = fn_appEnt(appEntKey) || {};
		dm.hdrTitle = 'View ' + ae.Name;
		dm.appEntKey = appEntKey;
		dm.recNo = recNo;
		dm.imporCompRec = ae.importRecComp;

		vc.$bvModal.show('bm-kbdp-view-rec');
	};
	kvr.showTask = (prntType, taskId, row, refDta, cbFn) => {
		vc.d_taskRec = {
			p_prntRecKey: prntType,
			p_mode: 'edit',
			p_taskId: taskId || undefined,
			p_taskData: row || undefined,
			p_refData: refDta || undefined,
			fn_saved: (tskDta) => {
				if (row) Object.keys(tskDta).forEach(k => row[k] = tskDta[k]);
				if (cbFn) cbFn(tskDta);
				vc.d_taskRec = null;
			}
		};
	};
	kvr.addTask = (prntType, tskDta, refDta, cbFn) => {
		vc.d_taskRec = {
			p_prntRecKey: prntType,
			p_mode: 'add',
			p_taskData: tskDta,
			p_refData: refDta || undefined,
			p_paeChg: true,
			fn_saved: (tskDta) => {
				if (cbFn) cbFn(tskDta);
				vc.d_taskRec = null;
			}
		};
	};
}

function fn_checkUnsavedChanges(vc, next) {
	let wss = window.sessionStorage;
	let uc = 'unsaved-changes';

	let doCheck = /^(edit|create)$/.test(vc.c_recMode) || wss[uc] == 'true';
	if (!doCheck) {
		fn_nextHelper();
		return;
	}

	let rtrUC = 'rtr-cnfrm-unsaved-changes';
	if (wss[rtrUC] == 'true') {return;}

	let rwSC = 'rec-wrap-save-cancel';
	if (wss[rwSC] == 'true') {
		wss.removeItem(rwSC);
		fn_nextHelper();
	}
	else {
		let content = {
			titleText: 'Unsaved Changes',
			message1: 'You may have unsaved changes in the record you are currently editing or creating.',
			message2: 'Are you sure you want to discard and leave the current page?',
		};

		let cm = util.fn_getModal_confirm(vc, content);
		
		cm.opt.okTitle += ', Leave';
		cm.opt.cancelTitle += ', Stay';
		wss.setItem(rtrUC, true);
		
		cm.opt.size='md';
        cm.opt.headerClass='p-2';
        cm.opt.headerBgVariant='primary';
        cm.opt.buttonSize='sm';
        cm.opt.okVariant='primary';
        cm.opt.footerClass='p-2 border-top-0';
        cm.opt.centered=true;
		
		vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
					wss.removeItem(rtrUC);
					wss.removeItem(uc);
					if(resp) fn_nextHelper();
						
		});
	}

	function fn_nextHelper() {
		next();
		// userReminders.fn_reCheck(15); //Only recheck with 15 min buffer, no need to do this really
	}
}


</script>

<style lang="less">
#KBDP {
	div.row.main-header {
		.col:first-child {
			display: flex;
			flex-wrap: wrap;
			padding: 0;
			// border: solid 0.1em red;
			> div {
				min-width: 160px;
				margin: auto;

				&:first-child {
					margin: auto;
					min-width: 160px;

					// border: solid 0.1em blue;
					@media (max-width: 576px) {
						min-width: 100px;
						img {
							height: 30px;
						}
					}
					img {
						cursor: pointer;
					}
				}
				&.tenant-info {
					// border: solid 0.1em blue;
					display: flex;
					flex-grow: 1;
					justify-content: center;

					> div:last-child {
						margin: auto 0.5em;
						min-width: 100px;
					}

					@media (max-width: 576px) {
						flex-grow: 0;
						min-width: 100px;
						img {
							height: 40px;
						}
					}
				}
			}
		}
		.col:last-child {
			padding: 0;
			max-width: 420px;
			flex-basis: 200px;
			margin: auto 0;
			> div {
				text-align: right;
				padding: 0.2em 0.3em;
			}

			@media (max-width: 576px) {
				max-width: unset;
				> div {
					text-align: center;
				}
			}
		}
	}
}
#kt-alert.fixed-bottom {
	margin: 0 auto;
	max-width: 500px;
	font-size: initial;
	text-align: left;
	z-index: 1051; //Must be above Modal + Backgrop
	div.alert {
		padding: 0.4em;
		min-height: 5em;
		max-height: 15em;
		border: solid 0.15em #adb5bd;
		display: flex;
		> button {
			right: 0.1em;
			top: 0.1em;
			padding: 0 0.2em;
			&:focus {
				outline: unset;
			}
		}
		> span {
			display: inline-block;
			margin: auto 0.4em;
			> svg {
				font-size: 1.5em;
			}
		}
		> pre {
			font-family: unset;
			margin: auto 1.2em auto 0.5em;
			white-space: pre-wrap;
		}
	}
}
#bm-kt-spinner {
	.modal-header {
		padding: 0;
		border-bottom: none;
		button {
			margin: 0;
			padding: 0 0.3em;
			color: #e9ecef;
			&:focus {
				outline: none;
			}
		}
	}
	.modal-body {
		padding-top: 0;
	}
}

#kbdp-main-nav {
	// min-height: 90vh;
	min-height: calc(100vh - 120px);
	max-width: calc(100% - 160px);
	@media (max-width: 576px) {
		max-width: unset;
	}

	> div > div.nav-header {
		> div:first-child {
			display: flex;
			padding: 0.2em 0;
			// margin-right: auto;
			> button {
				font-size: 0.9em;
				padding: 0.3em 0.4em;
				margin-right: 0.2em;
				color: #4fa4ff;
				line-height: 1em;
				min-width: 40px;
				&.active,
				&.focus {
					background-color: #4fa4ff;
					color: #fff;
				}
			}
			> span {
				font-size: 0.9em;
			}
		}
		> span.filter-note {
			padding: 0.2em 0; //N/A for calendar + dash
		}
		// > div.filter {
		// }
	}

	div.kt-related > div.card,
	> div > div > div.card {
		margin-top: 0.2em;
		margin-bottom: 1.25em;
		div.card-header {
			text-align: left;
			padding: 0.2em 0.5em;

			background-color: #e9ecef;
			> span {
				font-weight: bold;
				font-size: 15px;
				padding-right: 0.5em;
				vertical-align: middle;
			}
			> div.btn-group {
				flex-wrap: wrap;
				> span.btn-outline-secondary {
					font-size: 0.8em;
					padding: 0em 0.4em;
					margin: 0.2em;
					border-radius: 0.2em;
					flex-grow: 0;

					// &:hover {
					// 	background-color: #adb5bd; //Conflicts with touch hover disable
					// }
				}
				> span.btn-link {
					font-size: 0.8em;
					padding: 0;
					margin: auto 0.5em;
					font-weight: unset;
					flex-grow: 0;
				}
			}
		}
		div.card-body {
			padding: 0.2em 0.5em;
		}
	}

	> div.kbdp-main-info {
		display: flex;
		flex-direction: column;
		height: 100%;


		> .kt-home-dashboard {
			width: 100%;
			flex-shrink: 0;
			margin: 0.3em 0;
		}
		> .kt-announcements,
		> .kt-reminders {
			// min-height: 100px;
			width: 100%;
			flex-grow: 1;
			padding: 0.2em;
			margin: 0.3em 0;

			// border: solid 0.1em #dee2e6;
			border-radius: 0.25em;
		}
		> .kt-announcements {
			> div.header {
				text-align: center;
				padding: 0.2em 0.4em;
				border-bottom: solid 0.15em #adb5bd;
				> svg {
					margin-right: 0.5em;
				}
			}
			> div.items {
				overflow-y: auto;
				max-height: 300px;
				padding: 0.4em 0;
				div.item {
					font-size: 0.9em;
					text-align: left;
					padding: 0.4em;
					border-bottom: solid 0.1em #dee2e6;
					display: flex;
					flex-wrap: wrap;
					span.dt {
						font-weight: bolder;
						width: 75px;
						// border: solid 0.1em red;
					}
					span.txt {
						min-width: 245px;
						width: calc(100% - 75px);
						flex-grow: 1;
						font-size: 0.9em;
						white-space: pre-line;
						// border: solid 0.1em blue;
					}
				}
			}
		}
	}
}

#kbdp-side-nav {
	flex: 0 0 auto;
	width: auto;
	div.tap-close {
		display: none;
	}
	@media (max-width: 576px) {
		position: fixed;
		top: 0;
		width: 200px;
		height: 100%;
		z-index: 100;
		// background-color: rgb(252, 252, 252);
		background-color: #f8f9fa;

		div.tap-close {
			display: block;
			position: fixed;
			top: 0;
			right: 0;
			width: calc(100% - 200px);
			height: 100%;
			z-index: 100;

			// border: solid 0.1em red;
		}
	}
}
div.side-nav-collapsed {
	#kbdp-main-nav {
		max-width: calc(100% - 36px);
	}
	div.tap-close {
		display: none !important;
	}
	@media (max-width: 576px) {
		#kbdp-main-nav {
			max-width: unset;
		}
		#kbdp-side-nav {
			width: auto;
			height: unset;
			background-color: unset;
		}
	}
}

select option:disabled {
	color: #ced4da;
	&::after {
		content: "Disabled";
	}
}

.btn-cuFilter {
	&:not(.filtered) svg {
		opacity: 0.5;
	}
	&:hover svg,
	&.filtered svg {
		color: #4fa4ff;
		opacity: unset;
	}
	// svg[data-icon="user-alt"] {
	// 	opacity: 0.5;
	// }
	// svg[data-icon="user-check"] {
	// 	color: #4fa4ff;
	// }
}

div.kt-calendar-header,
div.kt-dashboard-header,
div.kt-sales-goals-header,
div.kt-revenue-forecasting-header,
div.nav-header {
	display: flex;
	flex-grow: 1;
	// justify-content: space-around;
	justify-content: space-between;
	flex-wrap: wrap;
	> span.filter-note {
		color: #dc3545;
		font-size: 0.9em;
		display: block;
		flex: 1 0 auto;

		margin: auto 0.4em;
		text-decoration: underline;
		// border: solid 0.1em blue;
	}
	> div.filter {
		display: flex;
		padding: 0.2em 0;
		> .btn-cuFilter {
			margin: auto 0;
		}
		> div.kt-select {
			text-align: left;
			margin-left: 0.25em;
			width: 290px;

			div.input {
				padding-top: 0em;
				padding-bottom: 0em;
			}
			div.options-container > div.info > span {
				> span {
					font-size: 0.85em;
				}
			}
		}
	}
}

// webkit/Firefox
// .rec-wrap.rec-task #bm-kt-task-key-taskChecklist > div,

#bm-kt-task div.modal-body,
#bm-kt-task div.ktt-cl > div:first-child,
// #bm-kt-task div.ktt-cl .checklist-item textarea,
#kt-calendar div.week-month div.events,
#kt-dashboard .kt-db-table .kt-table-table,
#kt-chat #side-nav-controls div.chats,
.kt-announcements .items,
.kt-reminders .items,
.kt-list .list-content,
.kt-select .sel-cont .options-container,
.kt-toolbar .col-toggle ul.dropdown-menu {
	&::-webkit-scrollbar {
		width: 0.4em;
		height: 0.8em;
		background-color: #fff;
	}
	&::-webkit-resizer {
		// width: 0.2em;
		// height: 0.2em;
		background-color: #e9ecef;
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 0.4em;
		background-color: #ced4da;
	}
	scrollbar-width: thin; //Firefox
}

#bm-kbdp-view-rec,
#bm-rec-wrap,
#bm-rec-wrap-nested {
	.modal-dialog.modal-lg .modal-content {
		min-height: 400px;
		max-height: 90vh;
		padding: 0.3em;

		.modal-body {
			padding: 0.5em 1em;
			overflow-y: auto;
			border: solid 0.1em #dee2e6;
		}
	}

	.modal-dialog .modal-content {
		.modal-header {
			padding: 0.2em 0.5em;
		}
		.modal-footer {
			padding: 0.5em;
			flex-wrap: wrap;

			button {
				padding: 0.2em 0.5em;
			}
			span.btn {
				font-size: 0.85em;
				padding: 0 0.3em;
				margin: 0;
				line-height: 1em;
			}
		}
	}
}

body {
	> div {
		.modal {
			.modal-footer {
				border-top: unset;
			}
		}
		.modal-backdrop {
			opacity: 0.2;
		}
	}

	.b-tooltip.tooltip {
		.tooltip-inner {
			text-align: left;
			max-width: 300px;
			white-space: pre-line;
		}
	}
}
.main-header-sticky{
	position:sticky; 
	top:15px; 
	background:white; 
	z-index:6;
	}
</style>